import React from "react";
import { Box, Heading, Checkbox, VStack } from "@chakra-ui/react";

const Checklist = ({ items = [] }) => {
  if (!items.length) return null;

  return (
    <Box mb={6}>
      <Heading size="sm" mb={2}>Checklist</Heading>
      <VStack align="start">
        {items.map(item => (
          <Checkbox key={item.id} isChecked={item.completed}>
            {item.label}
          </Checkbox>
        ))}
      </VStack>
    </Box>
  );
};

export default Checklist;